<template>
  <div class="menuTemplate">
    <van-tabs sticky animated v-model="menuTemplateId">
      <van-tab v-for="(item, index) in Treelist" :key="index">
        <template #title>
          <span @click="onClickTabs(item)" class="engineeringSpan">{{
            item.name
          }}</span>
        </template>
        <van-list
          v-model="loading"
          @load="getData"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          style="margin-top: 10px"
        >
          <van-swipe-cell v-for="(el, inx) in list" :key="inx">
            <div
              style="height: auto; min-height: auto; border-radius: 0"
              @click="wxClick(el)"
            >
              <div
                class="myDiv flexcolumn"
                :style="
                  el.fmtp09 == 1
                    ? 'box-shadow: none'
                    : 'background-color:#ffe98d;box-shadow: none;'
                "
              >
                <div class="flexLR" style="width: 100%">
                  <div class="flex" style="width: 62%">
                    <van-image
                      round
                      width="30"
                      height="30"
                      :src="$store.state.baseUrl + el.user13"
                    />
                    <div class="flex" style="width: 90%">
                      <h2 style="font-weight: bold">
                        {{ el.user04 }}
                      </h2>
                      <h2>
                        {{ el.famp10 }}
                      </h2>
                    </div>
                  </div>
                  <van-button
                    plain
                    round
                    type="info"
                    size="small"
                    @click="FindFormApplyDetail(el.fmap01)"
                    >查看</van-button
                  >
                </div>
                <div style="width: 100%; text-align: center; font-weight: bold">
                  <span v-if="el.famp13 == 1" style="color: red">催！</span
                  >{{
                    el.fmap03
                      ? el.fmap03.length >= 20
                        ? el.fmap03.substr(0, 30) + "..."
                        : el.fmap03
                      : ""
                  }}
                </div>
                <div
                  style="width: 100%; text-align: center; font-weight: bold"
                  v-if="el.isovertime == '已逾期'"
                >
                  <span style="color: red">{{ el.isovertime }}</span>
                </div>
                <div class="flexLR" style="width: 100%">
                  <div class="flexLR" style="width: 100%">
                    <!-- <div>阅读状态：{{ el.readnum }}人已读</div> -->
                    <div class="flexLR" style="width: 100%">
                      <span style="color: #00a1ff">
                        状态：{{ famp11(el.famp11) }}
                      </span>
                      <div>
                        {{ $route.query.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template #right>
              <div
                class="flexcolumn"
                style="height: 100%; width: 100px"
                v-if="menuTemplateId == 0"
              >
                <div class="flexLR" style="height: 100%; width: 100%">
                  <van-button
                    style="height: 100%; border-radius: 0; width: 100%"
                    type="info"
                    @click="BtnSubmitAudit(1, el.fmap01)"
                    size="mini"
                    >处理</van-button
                  >
                </div>
                <!-- <div class="flexLR" style="height: 100%;width:100%">
                  <van-button style="height: 100%;border-radius:0;width:100%" type="danger" size="mini"
                    @click="BtnSubmitAudit(2, el.fmap01)">驳回</van-button>
                </div> -->
              </div>
              <div
                class="flexcolumn"
                v-if="menuTemplateId != 1 && famp11(el.famp11) != '已通过'"
                style="height: 100%; width: 100px"
              >
                <div
                  class="flexLR"
                  style="height: 100%; width: 100%"
                  v-if="famp11(el.famp11) == '进行中'"
                >
                  <van-button
                    style="height: 100%; border-radius: 0; width: 100%"
                    @click="PressFormApply(el.fmap01)"
                    type="info"
                    size="mini"
                    >{{ el.famp13 == 0 ? "催办" : "已催" }}</van-button
                  >
                </div>
                <div
                  class="flexLR"
                  v-if="
                    el.famp11 != 4 &&
                    famp11(el.famp11) != '已完结' &&
                    famp11(el.famp11) != '未通过'
                  "
                  style="height: 100%; width: 100%"
                >
                  <van-button
                    style="height: 100%; border-radius: 0; width: 100%"
                    type="warning"
                    @click="CancelFormApply(el.fmap01)"
                    size="mini"
                    >撤回</van-button
                  >
                </div>
                <div
                  class="flexLR"
                  style="height: 100%; width: 100%"
                  v-if="famp11(el.famp11) == '已撤回'"
                >
                  <van-button
                    style="height: 100%; border-radius: 0; width: 100%"
                    type="info"
                    size="mini"
                    @click="
                      $router.push({
                        name: 'UpdateMenuTemplate',
                        query: { keyId: el.fmap01 },
                      })
                    "
                    >编辑</van-button
                  >
                </div>
                <div
                  class="flexLR"
                  style="height: 100%; width: 100%"
                  v-if="
                    famp11(el.famp11) == '未通过' ||
                    famp11(el.famp11) == '已撤回'
                  "
                >
                  <van-button
                    style="height: 100%; border-radius: 0; width: 100%"
                    type="danger"
                    size="mini"
                    @click="DelFormApply(el.fmap01)"
                    >删除</van-button
                  >
                </div>
              </div>
            </template>
          </van-swipe-cell>
        </van-list>
      </van-tab>
    </van-tabs>
    <div
      @click="addMemus"
      style="position: fixed; z-index: 9999; right: 40px; bottom: 20px"
    >
      <img
        round
        width="40"
        height="40"
        src="../../../assets/mobileImg/addBtn.png"
      />
    </div>
  </div>
</template>
<script>
import {
  GetFormApply,
  DelFormApply,
  PressFormApply,
  CancelFormApply,
} from "@/api/index";
export default {
  name: "menuTemplate",
  props: {},
  components: {},
  data() {
    return {
      menuTemplateId: 0,
      loading: false,
      finished: false,
      Treelist: [
        {
          name: "待处理",
          type: 2,
        },
        {
          name: "已处理",
          type: 3,
        },
        {
          name: "我发起的",
          type: 1,
        },
        {
          name: "抄送给我的",
          type: 4,
        },
      ],
      list: [],
    };
  },
  computed: {
    famp11() {
      return function (data) {
        switch (data) {
          case 1:
            return "进行中";
          case 2:
            return "已通过";
          case 3:
            return "未通过";
          case 4:
            return "已撤回";
          default:
            return "未知状态";
        }
      };
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.getData();
      },
      // 初始化执行一次
      immediate: true,
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    BtnSubmitAudit(type, id) {
      if (type == 1) {
        this.$router.push({
          name: "auditInfo",
          query: { id },
        });
      } else {
        this.rejectId = id;
        this.rejectShow = true;
      }
    },
    onClickTabs(v) {
      this.menuTemplateId = v.type;
      this.getData(v.type);
    },
    getData(type) {
      this.loading = true;
      this.finished = false;
      let params = {
        xid: localStorage.xid,
        uid: localStorage.id,
        type: type ? type : this.Treelist[this.menuTemplateId].type,
        searchword: "",
        pageIndex: 1,
        pageSize: 99999,
        tempId: this.$route.query.type,
        state: "null",
      };
      GetFormApply({ params }).then((res) => {
        this.list = res.Data.list;
        if (res.Data.list.length >= res.Data.total) {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    async DelFormApply(id) {
      let res = await DelFormApply({ id, qid: this.$store.state.qid });
      if (res.Code) {
        this.$Toast("删除成功");
        this.getData();
      }
    },
    async PressFormApply(id) {
      let res = await PressFormApply({ id });
      if (res.Code) {
        this.$Toast("催办成功");
        this.getData();
      }
    },
    async CancelFormApply(id) {
      let res = await CancelFormApply({ id });
      if (res.Code) {
        this.$Toast("撤回成功");
        this.getData();
      }
    },
    addMemus() {
      localStorage.setItem("query", this.$route.query.type);
      this.$router.push({
        name: "addMenu",
        query: {
          keyId: this.$route.query.type,
        },
      });
    },
    FindFormApplyDetail(id) {
      this.$router.push({
        name: "MenuInfo",
        query: {
          id: id,
        },
      });
    },
    wxClick() {},
  },
  created() {
    if (this.$route.query.type) {
      this.menuTemplateId = this.$route.query.type;
    }
    this.getData();
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.menuTemplate {
  .myDiv {
    width: 100%;
    padding: 10px 40px;
    border: 1px solid #dddddd;
  }

  width: 100%;
  // height: 100vh;
  margin: 0 auto;

  .van-tabs {
    height: auto;
  }

  /deep/ .van-tabs__line {
    background-color: rgb(255, 255, 255);
  }

  /deep/ .van-tabs__nav {
    background-color: rgba(255, 255, 255, 0);
  }

  .engineeringSpan {
    color: white;
  }

  /deep/ .van-tab__text {
    padding: 0 10px;
  }

  /deep/ .van-tab--active .van-tab__text .engineeringSpan {
    position: relative;
    z-index: 1;
    min-width: 62px;
    text-align: center;
    display: block;
    color: rgb(0, 119, 255);

    &::after {
      content: "";
      position: absolute;
      left: -5px;
      z-index: -1;
      top: 0;
      background-color: rgb(255, 255, 255);
      width: 100%;
      padding: 0 5px;
      border-radius: 10px;
      height: 100%;
    }
  }

  /deep/ .van-tabs__content {
    height: 93%;
    overflow: hidden;
    overflow-y: auto;
  }
}

.headTree {
  width: 100%;
  height: 40px;
  overflow: hidden;
  overflow-y: auto;
  background-color: #0095ff;
}
</style>
